// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `ion-badge {
  background: var(--ion-badge-bg-color) !important;
  position: absolute !important;
  font-size: 11px !important;
  top: 10px;
  z-index: 50 !important;
  padding: 1px 3px !important;
  margin-left: -13px !important;
}

ion-icon {
  color: var(--ion-header-text) !important;
  font-size: 24px;
  font-weight: 700 !important;
}`, "",{"version":3,"sources":["webpack://./src/app/right-menu/notification-chat/unread-chat/unread-chat.component.scss"],"names":[],"mappings":"AAAA;EACE,gDAAA;EACA,6BAAA;EACA,0BAAA;EACA,SAAA;EACA,sBAAA;EACA,2BAAA;EACA,6BAAA;AACF;;AAEA;EACE,wCAAA;EACA,eAAA;EACA,2BAAA;AACF","sourcesContent":["ion-badge {\n  background: var(--ion-badge-bg-color) !important;\n  position: absolute !important;\n  font-size: 11px !important;\n  top: 10px;\n  z-index: 50 !important;\n  padding: 1px 3px !important;\n  margin-left: -13px !important;\n}\n\nion-icon {\n  color: var(--ion-header-text) !important;\n  font-size: 24px;\n  font-weight: 700 !important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
